import { Controller } from "@hotwired/stimulus"

// Turbo を切ったフォーム(Stripe Checkout など外部へリダイレクトするもの)の
// 二重送信防止。Turbo 有効なフォームは Turbo 自身が submitter を無効化するが、
// data-turbo=false のフォームはその対象外で、jquery-ujs 廃止により Rails が
// submit_tag に出す data-disable-with も解釈されなくなったため、ここで補う。
export default class extends Controller {
  connect() {
    this.submitting = false
    this.onSubmit = this.onSubmit.bind(this)
    this.element.addEventListener("submit", this.onSubmit)

    // Turbo のスナップショットから復元すると disabled のまま戻りうるので、
    // 接続時に必ず押せる状態にする。
    this.submitters.forEach((submitter) => this.enable(submitter))
  }

  disconnect() {
    this.element.removeEventListener("submit", this.onSubmit)
  }

  onSubmit(event) {
    if (this.submitting) {
      event.preventDefault()
      return
    }
    this.submitting = true

    // 送信データが集まる前に disabled にすると submitter の name/value が
    // 送信対象から外れるため、送信が始まった後のタスクで無効化する。
    setTimeout(() => this.disable(this.submitterFor(event)), 0)
  }

  // event.submitter は環境によってフォーム自身が入ることがある。無関係な要素を
  // 無効化しないよう、このフォームの submit コントロールに限定する。
  submitterFor(event) {
    const submitters = this.submitters
    return submitters.includes(event.submitter) ? event.submitter : submitters[0]
  }

  get submitters() {
    return Array.from(this.element.querySelectorAll("input[type=submit], button[type=submit]"))
  }

  disable(submitter) {
    if (!submitter) return

    const label = submitter.dataset.disableWith
    if (label) {
      if (submitter.tagName === "INPUT") {
        submitter.dataset.enableWith = submitter.value
        submitter.value = label
      } else {
        submitter.dataset.enableWith = submitter.innerHTML
        submitter.innerHTML = label
      }
    }
    submitter.disabled = true
  }

  enable(submitter) {
    const label = submitter.dataset.enableWith
    if (label !== undefined) {
      if (submitter.tagName === "INPUT") {
        submitter.value = label
      } else {
        submitter.innerHTML = label
      }
      delete submitter.dataset.enableWith
    }
    submitter.disabled = false
  }
}
